interface ITextFieldSkeleton {
  isLoading?: boolean
  children: React.ReactNode
  invert?: boolean
}
const TitleSubtitleSkeleton: React.FC<ITextFieldSkeleton> = ({
  isLoading,
  children,
  invert = false
}) => {
  const renderSkeleton = () => {
    if (!invert) {
      return (
        <>
          <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-300 w-48 mb-4"></div>
          <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-300 max-w-[100px] mb-2.5"></div>
        </>
      )
    } else {
      return (
        <>
          <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-300 max-w-[100px] mb-2.5"></div>
          <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-300 w-48 mb-4"></div>
        </>
      )
    }
  }
  return (
    <>
      {isLoading ? (
        <div role="status" className="max-w-sm animate-pulse">
          {renderSkeleton()}
          <span className="sr-only">Loading...</span>
        </div>
      ) : (
        children
      )}
    </>
  )
}

export default TitleSubtitleSkeleton
